export class Location {
  address1;
  address2;
  adminPassword;
  adminUsername;
  alertEmailAddressList;
  city;
  clientId;
  connectionType;
  country;
  county;
  created;
  gatewayDeviceString;
  gatewayFirmwareVersion;
  gatewayType;
  ip4Address;
  ip6Address;
  ipAssignment;
  ispName;
  lastUpdated;
  lat;
  lineType;
  id;
  lng;
  name;
  primaryPhone;
  ratedDownstreamDatarate;
  ratedUpstreamDatarate;
  secondaryPhone;
  state;
  status;
  timeZone;
  venueCode;
  venueId;
  venueTypeId;
  websiteUrl;
  zip;
  _$visited;

  constructor(obj?: Location) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/location-setup/location.model.ts